import styled from "styled-components";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";

import { Link } from "react-router-dom";
import {
  Box,
} from '@mui/material';

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
`;

const NotFound = () => {
  return (
    <Container>
      <Topbar />
      <Box sx={{
        textAlign: 'center'
      }}>
        <Title>Oops. Page not found</Title>
        <p>
          <Link to="/">Go to the home page</Link>
        </p>
      </Box>
      <Footer/>
    </Container>
  );
};

export default NotFound;
